export default "__VITE_ASSET__CzzmWtXJ__"